CustomTC.define('modules/settings/settings',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/language', 'modules/transcriptions/transcriptions', 'text!modules/settings/htmls/settings.html', 'css!modules/settings/css/settings'], function(util, core, config, constants, options, language, transcriptions, settings) {
    return {
        settingsShow: false,
        settingsInited: false,
        init: function(playerUI) {
            this.playerUI = playerUI;
            if (!this.settingsInited) {
                core.init('body').find('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').append(settings);
            }
            this.settingsInited = true;
            this.initSettingsPanel();
            this.initSubtitlesPanel();
            this.resize(playerUI);
        },
        initSettingsPanel: function() {
            var self = this;
            var settingsBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SETTINGS + '');
            var settingsPanel = core.init('.' + constants.CSS_TOUCHCAST_SETTINGS_VALUES + '');
            var settingsPanelItem = core.init('.' + constants.CSS_TOUCHCAST_SETTINGS_PANEL + '');
            var subtitlesPanel = core.init('.' + constants.CSS_TOUCHCAST_SUBTITLES_PANEL + '');
            core.off(settingsBtn, 'touchstart click');
            core.on(settingsBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                core.tooltipster(settingsBtn, 'disable');
                if (!core.hasClass(settingsPanel, constants.CSS_TOUCHCAST_OPEN)) {
                    core.removeClass(settingsPanel, constants.CSS_TOUCHCAST_OPEN);
                    core.addClass(settingsPanel, constants.CSS_TOUCHCAST_OPEN);
                    core.addClass(settingsPanelItem, constants.CSS_TOUCHCAST_OPEN);
                    core.removeClass(subtitlesPanel, constants.CSS_TOUCHCAST_OPEN);
                    core.addClass(settingsBtn, constants.CSS_TOUCHCAST_SETTINGS_SHOW_POPUP_ARROW);
                } else {
                    core.tooltipster(settingsBtn, 'enable');
                    core.removeClass(settingsPanel, constants.CSS_TOUCHCAST_OPEN);
                    core.removeClass(settingsPanelItem, constants.CSS_TOUCHCAST_OPEN);
                    core.removeClass(settingsBtn, constants.CSS_TOUCHCAST_SETTINGS_SHOW_POPUP_ARROW);
                }
            });
        },
        initSubtitlesPanel: function() {
            var self = this;
            core.empty(core.init('.' + constants.CSS_TOUCHCAST_SUBTITLES_PANEL + ' ul'));
            var subtitles = transcriptions.subtitles;
            var cnt = 0;
            for (i in subtitles) {
                cnt++;
                if (options.getDefaultSubtitle() == '') {
                    if (i == 0) {
                        core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_SELECTED_LANG + '').html(language.getSubtitleLabel(subtitles[i]['type']));
                        var selected = 'selectedLang';
                    } else {
                        var selected = '';
                    }
                } else {
                    if (subtitles[i]['type'] == options.getDefaultSubtitle()) {
                        core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_SELECTED_LANG + '').html(language.getSubtitleLabel(subtitles[i]['type']));
                        var selected = 'selectedLang';
                    } else {
                        var selected = '';
                    }
                }
                core.append(core.init('.' + constants.CSS_TOUCHCAST_SUBTITLES_PANEL + ' ul'), '<li class="tcBorderTop tcSubtitlesLangs"><a href="javascript:void(0);" class="tcLangsList tcCustomBgHover tcHoverActive ' + selected + '" data-subtitle="' + subtitles[i]['type'] + '">' + language.getSubtitleLabel(subtitles[i]['type']) + '</a></li>');
            }
            if (cnt > 1) {
                self.settingsShow = true;
            }
            var subtitlesBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES + '');
            var subtitlesPanel = core.init('.' + constants.CSS_TOUCHCAST_SUBTITLES_PANEL + '');
            var settingsPanel = core.init('.' + constants.CSS_TOUCHCAST_SETTINGS_PANEL + '');
            var subtitlesPanelTitle = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_TITLE + '');
            core.off(subtitlesBtn, 'touchstart click');
            core.on(subtitlesBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                self.resize();
                core.removeClass(subtitlesPanel, constants.CSS_TOUCHCAST_OPEN);
                core.addClass(subtitlesPanel, constants.CSS_TOUCHCAST_OPEN);
                core.removeClass(settingsPanel, constants.CSS_TOUCHCAST_OPEN);

            });
            core.off(subtitlesPanelTitle, 'touch click');
            core.on(subtitlesPanelTitle, 'touch click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                core.addClass(settingsPanel, constants.CSS_TOUCHCAST_OPEN);
                core.removeClass(subtitlesPanel, constants.CSS_TOUCHCAST_OPEN);

            });

        },
        removeSettingsPanel: function() {
            var settingsBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SETTINGS + '');
            var settingsPanel = core.init('.' + constants.CSS_TOUCHCAST_SETTINGS_VALUES + '');
            var settingsPanelItem = core.init('.' + constants.CSS_TOUCHCAST_SETTINGS_PANEL + '');
            core.tooltipster(settingsBtn, 'enable');
            core.removeClass(settingsPanel, constants.CSS_TOUCHCAST_OPEN);
            core.removeClass(settingsPanelItem, constants.CSS_TOUCHCAST_OPEN);
            core.removeClass(settingsBtn, constants.CSS_TOUCHCAST_SETTINGS_SHOW_POPUP_ARROW);
        },
        resize: function(playerUI) {
            if (typeof playerUI !== 'undefined') {
                if ((util.isiPod() || util.isiPhone()) && !options.isHls()) {
                    if (!core.isEmptyObject(options.getVideoInfo()[0].subtitles)) {
                        if (this.settingsShow != false) {
                            playerUI.showSettingsButton();
                        }
                        playerUI.showTranscriptButton();
                    } else {
                        playerUI.hideSettingsButton();
                        playerUI.hideTranscriptButton();
                        this.removeSettingsPanel();
                    }
                }
            }
            core.setCss(core.init('.' + constants.CSS_TOUCHCAST_SUBTITLES_PANEL + ' ul'), {
                'max-height': (core.getHeight(core.init('.' + constants.CSS_TOUCHCAST_PLAYER_ELEMENT + '')) - 100) + 'px'
            });
        },

    }
});
